import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, Button, Card, Avatar } from '@radix-ui/themes';
import { Cross2Icon, SymbolIcon } from '@radix-ui/react-icons';
import SchoolSearch from '../../schoolSearch/SchoolSearch';
import api from '../../../api';
import { useSelector, useDispatch } from 'react-redux';
import { verificationService } from '../../../services/verificationService';
import { updateTeacherVerification } from '../../../redux/slices/teacherAccountSlice';

const TeacherVerification = () => {
    const [selectedSchoolId, setSelectedSchoolId] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const verification = useSelector(state => state.teacherAccount.verification);
    console.log('verification', verification);

    // useEffect(() => {
    //     checkVerificationStatus();
    // }, []);

    const checkVerificationStatus = async () => {
        try {
            console.log('checking verification status');
            setLoading(true);
            const data = await verificationService.getVerificationStatus();
            console.log('data', data);
            dispatch(updateTeacherVerification(data));
        } catch (error) {
            console.error('Error checking verification status:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleVerificationRequest = async () => {
        try {
            const data = await verificationService.requestVerification(selectedSchoolId);
            console.log('data', data);
            dispatch(updateTeacherVerification(data));
        } catch (error) {
            console.error('Error requesting verification:', error);
        }
    };

    const handleCancelVerification = async () => {
        try {
            const data = await verificationService.cancelVerification(verification.id);
            console.log('cancel verificationdata', data);
            dispatch(updateTeacherVerification(data));
        } catch (error) {
            console.error('Error canceling verification:', error);  
        }
    };

    if (loading) {
        return <Text>Loading...</Text>;
    }

    const renderVerification = () => {

        if (verification?.status == 'pending') {
            return (
                <Flex direction="column" align="start" gap="4" width="100%">
                    <Text size="2" weight="bold" color="orange">
                        Verification Pending
                    </Text>

                    <Flex direction="row" gap="4" align="center" width="100%">
                        {verification.school.crest != '' ? <Avatar size="3" src={`${import.meta.env.VITE_PUBLIC_URL}/storage/${verification.school.crest}`} /> : <Avatar size="3" src={'/images/defaultCrest.png'} />}
                        <Box align="start" style={{ flex: 1 }}>
                            <Text as="p" size="1" weight="bold">{verification.school.name}</Text>
                            <Text as="p" size="1">{verification.school.location}</Text>
                        </Box>
                        <Flex direction="column" gap="1" align="end">
                            <Text size="1" color="gray">
                                Requested on:
                            </Text>
                            <Text size="1" color="gray">
                                {new Date(verification.created_at).toLocaleDateString()}
                            </Text>
                        </Flex>
                    </Flex>
                    <Button variant="ghost" color="red" onClick={handleCancelVerification}><Cross2Icon /> Cancel Verification</Button>
                </Flex>
            );
        }

        else if (verification?.status == 'approved') {
            return (
                <Flex direction="column" align="start" gap="2" width="100%">
                        <Text size="2" weight="bold" color="green">Verified</Text>
                    <Flex direction="row" gap="4" align="center" width="100%">
                        {verification.school.crest != '' ? <Avatar size="3" src={`${import.meta.env.VITE_PUBLIC_URL}/storage/${verification.school.crest}`} /> : <Avatar size="3" src={'/images/defaultCrest.png'} />}
                        <Box align="start" style={{ flex: 1 }}>
                            <Text as="p" size="1" weight="bold">{verification.school.name}</Text>
                            <Text as="p" size="1">{verification.school.location}</Text>
                        </Box> 
                        <Flex direction="column" gap="1" align="end">
                            <Text size="1" color="gray">
                                Verified on:
                            </Text>
                            <Text size="1" color="gray">
                                {new Date(verification.verified_at).toLocaleDateString()}
                            </Text>
                        </Flex>
                    </Flex>
                    
                    <Button variant="ghost" color="red" onClick={handleCancelVerification}><Cross2Icon /> Cancel Verification</Button>
                </Flex>
            );
        } else {
            return (
            <Flex direction="column" gap="2" width="100%">
                <Text size="1">
                    Send a request to your school to verify your account
                </Text>
                <SchoolSearch 
                    onSelect={setSelectedSchoolId}
                    selectedSchoolId={selectedSchoolId}
                />
                <Button 
                    onClick={handleVerificationRequest}
                    disabled={!selectedSchoolId}
                    style={{alignSelf: 'flex-start'}}
                >
                    Request Verification
                </Button>
            </Flex>
                );
        }
    }   
        
        
        
    

    return (
        <Flex direction="column" align="start" gap="3" width="100%">
            {renderVerification()}
            <Button variant="outline" style={{alignSelf: 'flex-end'}} onClick={checkVerificationStatus}><SymbolIcon /></Button>
        </Flex>
    );
};

export default TeacherVerification;
